
                import "css-modules://src_components_text_text"
                export default {"Main":"_acf22f","Text":"_e9d609","Visible":"_4dd7ca","Sidebar":"_d8ab43","Link":"_207910","Icon":"_9d0af0"}
            